import { forwardRef, InputHTMLAttributes } from 'react';
import clsx from 'clsx';
import styles from './input-redesigned.module.scss';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: any;
    success?: boolean;
}

export const InputRedesigned = forwardRef<HTMLInputElement, Props>(
    ({ label, error, success, className, required, disabled, ...rest }, ref) => {
        return (
            <input
                ref={ref}
                className={clsx(
                    styles.input,
                    {
                        [styles.error]: error,
                        [styles.success]: success && !error,
                        [styles.disabled]: disabled,
                    },
                    className,
                )}
                disabled={disabled}
                {...rest} />
        );
    },
);
InputRedesigned.displayName = 'InputRedesigned';
